import { Alert, Platform } from 'react-native';

type AlertButton = {
  text: string;
  onPress?: () => void;
  style?: 'default' | 'cancel' | 'destructive';
};

// Variable global para almacenar la función que muestra el AlertDialog en web
let showAlertDialogOnWeb: (
  title: string,
  message?: string,
  buttons?: AlertButton[]
) => void;

export const setAlertDialogHandler = (
  handler: (title: string, message?: string, buttons?: AlertButton[]) => void
) => {
  showAlertDialogOnWeb = handler;
};

// Función unificada para mostrar alertas que funciona en web y móvil
export const showAlert = (
  title: string,
  message?: string,
  buttons: AlertButton[] = [{ text: 'OK' }]
) => {
  if (Platform.OS === 'web' && showAlertDialogOnWeb) {
    showAlertDialogOnWeb(title, message, buttons);
  } else {
    // Usar el Alert nativo en plataformas móviles
    Alert.alert(title, message, buttons as any);
  }
}; 